import { useSelector } from "react-redux";
import { Navigate, Route, Routes, useParams } from "react-router-dom";
import AdminOptions from "../pages/dashboardPage/adminOptions/AdminOptions";
import AppVersionSettings from "../pages/dashboardPage/appVersionSettings/AppVersionSettings";
import CustomerService from "../pages/dashboardPage/customerService/CustomerService";
import EmployeeSettings from "../pages/dashboardPage/emloyeeSettings/EmployeeSettings";
import RegionSettings from "../pages/dashboardPage/regionSettings/RegionSettings";
import SocialMediaSettings from "../pages/dashboardPage/socialMediaSettings/SocialMediaSettings";
import Timeline from "../pages/dashboardPage/timeline/Timeline";
import TournamentSettings from "../pages/dashboardPage/tournamentSettings/TournamentSettings";
import UserSettings from "../pages/dashboardPage/userSettings/UserSettings";
import TournamentsComments from "../pages/dashboardPage/tournamentsComments/TournamentsComments";
import SquadSettings from "../pages/dashboardPage/squadSettings/SquadSettings";
import Logs from "../pages/dashboardPage/logs/Logs";
import Developer from "../pages/dashboardPage/developer/Developer";
import SupportTicketsSection from "../pages/dashboardPage/supportTickets/SupportTicketsSection";
import { canOpenSection } from "../constants/permissionCatalog";

const LegacyTablesRedirect = () => {
  const { tournamentId } = useParams();
  return <Navigate to={`/dashboard/tournaments/tournament-tables/${tournamentId}`} replace />;
};

const DashboardInnerNavigator = () => {
  const { rolePermissions } = useSelector((state) => state.user);

  return (
    <Routes>
      {canOpenSection(rolePermissions, "admin-options") && (
        <Route path="/admin-options/*" element={<AdminOptions />} />
      )}
      {canOpenSection(rolePermissions, "employees") && (
        <Route path="/emlpoyees/*" element={<EmployeeSettings />} />
      )}
      {canOpenSection(rolePermissions, "logs") && (
        <Route path="/logs/*" element={<Logs />} />
      )}
      {canOpenSection(rolePermissions, "tournaments") && (
        <Route path="/tournaments/*" element={<TournamentSettings />} />
      )}
      {canOpenSection(rolePermissions, "regions") && (
        <Route path="/regions/*" element={<RegionSettings />} />
      )}
      {canOpenSection(rolePermissions, "users") && (
        <Route path="/users/*" element={<UserSettings />} />
      )}
      {canOpenSection(rolePermissions, "squads") && (
        <Route path="/squads/*" element={<SquadSettings />} />
      )}
      {canOpenSection(rolePermissions, "timelines") && (
        <Route path="/timelines/*" element={<Timeline />} />
      )}
      {/* جداول البطولات is no longer a section: a tournament's tables open from its
          card under ادارة البطولات. Old links redirect there. */}
      <Route
        path="/tournament-tables/show-tournament-tables/:tournamentId"
        element={<LegacyTablesRedirect />}
      />
      <Route path="/tournament-tables/*" element={<Navigate to="/dashboard/tournaments" replace />} />
      {canOpenSection(rolePermissions, "customer-support") && (
        <Route path="/customer-support/*" element={<CustomerService />} />
      )}
      {canOpenSection(rolePermissions, "support-tickets") && (
        <Route path="/support-tickets/*" element={<SupportTicketsSection />} />
      )}
      {canOpenSection(rolePermissions, "tournament-comments") && (
        <Route
          path="/tournaments-comments/*"
          element={<TournamentsComments />}
        />
      )}
      {canOpenSection(rolePermissions, "social-media") && (
        <Route path="/social-media/*" element={<SocialMediaSettings />} />
      )}
      {canOpenSection(rolePermissions, "app-settings") && (
        <Route path="/app-settings/*" element={<AppVersionSettings />} />
      )}
      {canOpenSection(rolePermissions, "developer") && (
        <Route path="/developer/*" element={<Developer />} />
      )}
    </Routes>
  );
};

export default DashboardInnerNavigator;
